var $45bfab0ff7a43567$exports = {};
const $45bfab0ff7a43567$var$TRIGGER = '.popover__content--displayed button';
const $45bfab0ff7a43567$var$SURFACE = '.popover__content';
let $45bfab0ff7a43567$var$popoverIds = 0;
class $45bfab0ff7a43567$var$ElmPopover extends HTMLElement {
    connectedCallback() {
        this.popoverId ??= `elm-popover-${++$45bfab0ff7a43567$var$popoverIds}`;
        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onSurfaceClick = this.onSurfaceClick.bind(this);
        this.onDocumentKeyDown = this.onDocumentKeyDown.bind(this);
        this.onCloseRequest = this.onCloseRequest.bind(this);
        this.addEventListener('close', this.onCloseRequest);
        this.wire();
        this.observer = new MutationObserver(()=>this.wire());
        this.observer.observe(this, {
            childList: true,
            subtree: true
        });
    }
    disconnectedCallback() {
        this.close();
        this.observer.disconnect();
        this.trigger?.removeEventListener('click', this.onTriggerClick);
        this.trigger = undefined;
        this.surface = undefined;
        this.removeEventListener('close', this.onCloseRequest);
    }
    own(selector) {
        const found = this.querySelector(selector);
        return found && found.closest('elm-popover') === this ? found : null;
    }
    wire() {
        const trigger = this.own($45bfab0ff7a43567$var$TRIGGER);
        const surface = this.own($45bfab0ff7a43567$var$SURFACE);
        if (!trigger || !surface) return;
        if (trigger !== this.trigger) {
            this.trigger?.removeEventListener('click', this.onTriggerClick);
            trigger.addEventListener('click', this.onTriggerClick);
            this.trigger = trigger;
        }
        if (surface !== this.surface) {
            if (this.open && this.surface) this.surface.removeEventListener('click', this.onSurfaceClick);
            if (this.open) surface.addEventListener('click', this.onSurfaceClick);
            this.surface = surface;
        }
        surface.id ||= `${this.popoverId}-surface`;
        trigger.setAttribute('aria-controls', surface.id);
        this.reflect();
    }
    // The open state lives on an attribute this element owns. Writing it into the
    // wrapper's class would put it in a string Elm rewrites wholesale whenever any
    // other class on that node becomes model-dependent.
    reflect() {
        const open = this.open === true;
        this.toggleAttribute('open', open);
        this.trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.setAttribute('data-escape-layer', open ? 'open' : 'closed');
    }
    onTriggerClick() {
        if (this.open) this.close();
        else this.openPopover();
    }
    openPopover() {
        if (this.open) return;
        this.open = true;
        this.reflect();
        document.addEventListener('pointerdown', this.onDocumentPointerDown, true);
        this.addEventListener('focusout', this.onFocusOut);
        this.surface?.addEventListener('click', this.onSurfaceClick);
        if (!this.closest('elm-modal')) document.addEventListener('keydown', this.onDocumentKeyDown);
        this.dispatchEvent(new CustomEvent('open', {
            bubbles: false
        }));
    }
    close() {
        if (!this.open) return;
        const hadFocus = this.contains(document.activeElement);
        this.open = false;
        this.reflect();
        document.removeEventListener('pointerdown', this.onDocumentPointerDown, true);
        this.removeEventListener('focusout', this.onFocusOut);
        this.surface?.removeEventListener('click', this.onSurfaceClick);
        document.removeEventListener('keydown', this.onDocumentKeyDown);
        if (hadFocus && this.trigger?.isConnected) this.trigger.focus();
    }
    onDocumentPointerDown(event) {
        if (!this.contains(event.target)) this.close();
    }
    onFocusOut(event) {
        if (!event.relatedTarget) return;
        if (!this.contains(event.relatedTarget)) this.close();
    }
    onSurfaceClick(event) {
        if (event.target.closest('button, a[href]')) this.close();
    }
    onDocumentKeyDown(event) {
        if (event.key !== 'Escape' || event.defaultPrevented) return;
        event.preventDefault();
        this.close();
    }
    onCloseRequest() {
        this.close();
    }
}
if (!customElements.get('elm-popover')) customElements.define('elm-popover', $45bfab0ff7a43567$var$ElmPopover);


//# sourceMappingURL=provider-portal.47099822.js.map
